import { ReactNode } from 'react';

type DraggablePropsType = {
    handleDragStart: () => void;
    handleDragEnd: () => void;
    children: ReactNode;
    className?: string | undefined;
};
export function Draggable({ handleDragStart, handleDragEnd, children, className }: DraggablePropsType) {
    return (
        <div draggable className={className} onDragStart={() => handleDragStart()} onDragEnd={handleDragEnd}>
            {children}
        </div>
    );
}

type DroppablePropsType = {
    handleDragEnter: () => void;
    handleDragOver: (e: React.DragEvent) => void;
    handleDrop: () => void;
    children: ReactNode;
    className?: string | undefined;
};
export function Droppable({ handleDragEnter, handleDragOver, handleDrop, children, className }: DroppablePropsType) {
    return (
        <div onDragEnter={handleDragEnter} onDragOver={handleDragOver} onDrop={handleDrop} className={className}>
            {children}
        </div>
    );
}

type DragAndDropZonePropsType = {
    handleDragEnter: () => void;
    children: ReactNode;
    className?: string | undefined;
};
export function DragAndDropZone({ handleDragEnter, children, className }: DragAndDropZonePropsType) {
    return (
        <div onDragEnter={handleDragEnter} className={className}>
            {children}
        </div>
    );
}
